import { Stack, StackPage, StackSwitch, StackSwitchApiContext, usePersistedStateId } from "@comet/admin";
import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import { PageHeader } from "@src/components";
import { useContext } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { AddPackage } from "./add/Package";
import { EditPackage } from "./edit/Package";
import PackageTable from "./Table";

export const AddButton = () => {
    const stackApi = useContext(StackSwitchApiContext);

    return (
        <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleOutline style={{ fontSize: "20px" }} />}
            onClick={() => stackApi.activatePage("add", "package")}
        >
            <FormattedMessage id="reviermanager.page.package.add" defaultMessage="Paket hinzufügen" />
        </Button>
    );
};

export default () => {
    const intl = useIntl();
    const persistedStateId = usePersistedStateId();

    return (
        <Stack topLevelTitle={intl.formatMessage({ id: "reviermanager.page.packages.main", defaultMessage: "Pakete" })}>
            <StackSwitch initialPage="table">
                <StackPage name="table">
                    <PageHeader title={<FormattedMessage id="reviermanager.page.packages.main" defaultMessage="Pakete" />} button={<AddButton />} />
                    <PackageTable persistedStateId={persistedStateId} />
                </StackPage>
                <StackPage name="add" title={intl.formatMessage({ id: "reviermanager.page.packages.add", defaultMessage: "Paket hinzufügen" })}>
                    <AddPackage />
                </StackPage>
                <StackPage name="edit" title={intl.formatMessage({ id: "reviermanager.page.packages.edit", defaultMessage: "Paket bearbeiten" })}>
                    {(id) => <EditPackage id={id} />}
                </StackPage>
            </StackSwitch>
        </Stack>
    );
};
